import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, MessageSquare, Clock, ArrowRight } from 'lucide-react';
import Header from '@/components/public/Header';
import Footer from '@/components/public/Footer';
import { SEOHead } from '@/components/seo';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Contact StartEase Agent — Investment Drafting & US Formation | StartEase Agent"
        description="Get in touch with StartEase Agent for investment document drafting, US company formation, or compliance support. We respond within 24 hours."
        canonical="https://starteaseai.com/contact"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="bg-slate-900 py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Contact Us
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Have questions about our services? Our team is here to help you start and grow your business.
          </p>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-16">
        <div className="container-custom">
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {/* Email */}
            <div className="bg-slate-50 rounded-xl p-8 text-center">
              <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-7 h-7 text-emerald-600" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">Email Us</h3>
              <p className="text-slate-600 mb-4">Get a response within 24 hours</p>
              <a 
                href="mailto:hi@starteaseai.com" 
                className="text-emerald-600 font-medium hover:text-emerald-700"
              >
                hi@starteaseai.com
              </a>
            </div>

            {/* Phone */}
            <div className="bg-slate-50 rounded-xl p-8 text-center">
              <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="w-7 h-7 text-emerald-600" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">Call Us</h3>
              <p className="text-slate-600 mb-4">Mon-Fri, 9am-6pm EST</p>
              <a 
                href="tel:+19295550247" 
                className="text-emerald-600 font-medium hover:text-emerald-700"
              >
                +1 (929) 555-0247
              </a>
            </div>

            {/* Office */}
            <div className="bg-slate-50 rounded-xl p-8 text-center">
              <div className="w-14 h-14 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-7 h-7 text-emerald-600" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">Visit Us</h3>
              <p className="text-slate-600 mb-4">Our headquarters</p>
              <p className="text-slate-700">
                Startease Agent LLC<br />
                418 Broadway #5781<br />
                Albany, NY 12207<br />
                United States
              </p>
            </div>
          </div>

          {/* FAQ Link */}
          <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-8 text-center">
            <MessageSquare className="w-10 h-10 text-emerald-600 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-slate-900 mb-2">
              Looking for quick answers?
            </h3>
            <p className="text-slate-600 mb-6">
              Check our FAQ section for answers to common questions about business formation, pricing, and our services.
            </p>
            <Link 
              to="/faq"
              className="inline-flex items-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-emerald-700 transition-colors"
            >
              View FAQ <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Business Hours */}
      <section className="py-16 bg-slate-50">
        <div className="container-custom">
          <div className="max-w-xl mx-auto text-center">
            <Clock className="w-10 h-10 text-emerald-600 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-slate-900 mb-6">Business Hours</h2>
            <div className="space-y-2 text-slate-600">
              <p><span className="font-medium text-slate-900">Monday - Friday:</span> 9:00 AM - 6:00 PM EST</p>
              <p><span className="font-medium text-slate-900">Saturday:</span> 10:00 AM - 2:00 PM EST</p>
              <p><span className="font-medium text-slate-900">Sunday:</span> Closed</p>
            </div>
            <p className="mt-6 text-sm text-slate-500">
              * Online orders are processed 24/7. Support inquiries received outside business hours will be addressed the next business day.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
